 document.addEventListener("DOMContentLoaded", function() {
    // Initialize the custom image slider
    var customImageSlider = new Swiper(".customImageSwiper", {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 5000,
      freeMode: true,
      freeModeMomentum: false
    });

    // Clone slides if needed for continuous scrolling
    var customSlides = document.querySelectorAll(".customImageSwiper .swiper-slide");
    var customWrapper = document.querySelector(".customImageSwiper .swiper-wrapper");

    if (customSlides.length < 6 && customWrapper) {
      customSlides.forEach(function(slide) {
        customWrapper.appendChild(slide.cloneNode(true));
        customWrapper.appendChild(slide.cloneNode(true));
      });
    }
  });